import create from "zustand";
import { persist } from "zustand/middleware";

export const userStore = create(
  persist((set) => ({
    setExhibitionData: (data) => {
        set({ exhibition: data });
    },
    setOfficialData: (data) => {
        set({ official: data });
    }
  }))
);